var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Col',{attrs:{"span":_vm.config.span || 8}},[(_vm.isShow)?_c('FormItem',{style:({
      marginBottom: _vm.config.props.bottom ? `${_vm.config.props.bottom}px` : '10px'
    }),attrs:{"label":`${_vm.config.label}`}},[_c('Cascader',{attrs:{"placeholder":_vm.config.placeholder,"clearable":"","filterable":"","change-on-select":"","data":_vm.config.options,"disabled":_vm.disabled},model:{value:(_vm.cascadeModel),callback:function ($$v) {_vm.cascadeModel=$$v},expression:"cascadeModel"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }